import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeClass as _normalizeClass, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-acdd007c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "menu"
};
import { ref, computed } from 'vue';
import MyMenu from "./MyMenu";
import Content from "./header/Content";
import { useStore } from 'vuex';
export default {
  __name: 'index',
  setup(__props) {
    const store = useStore();
    const isClose = ref(localStorage.getItem('menuIsClose') === 'true' ? true : false);

    // 获取需要缓存的组件名列表
    const cachedViews = computed(() => store.state.cachedViews);
    const change = () => {
      isClose.value = !isClose.value;
      localStorage.setItem('menuIsClose', isClose.value);
    };
    return (_ctx, _cache) => {
      const _component_router_view = _resolveComponent("router-view");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createVNode(_unref(MyMenu), {
        isClose: isClose.value
      }, null, 8, ["isClose"])]), _createElementVNode("div", {
        class: _normalizeClass(["content", {
          active: isClose.value
        }])
      }, [_createVNode(_unref(Content), {
        isClose: isClose.value,
        onChange: change
      }, {
        default: _withCtx(() => [_createVNode(_component_router_view)]),
        _: 1
      }, 8, ["isClose"])], 2)], 64);
    };
  }
};